import { createSlice } from "@reduxjs/toolkit";
import { fetchIndustry_sector_childItems } from "./Industry_sector_childThunks";

const initialState = {
  items: [],
  loading: false,
  error: null,
};

const industry_sector_childSlice = createSlice({
  name: "industry_sector_child",
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchIndustry_sector_childItems.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchIndustry_sector_childItems.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(fetchIndustry_sector_childItems.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default industry_sector_childSlice.reducer;